import React from 'react'
import './App.css'
import Spinner from 'react-bootstrap/Spinner';
import logo from './Pages/assets/custom.webp'
import HomeSvg from './Pages/assets/home_svg'
import MenuSvg from './Pages/assets/menu_svg'
import MsgSvg from './Pages/assets/msg_svg'
import FaceSvg from './Pages/assets/media/facebook.png'
import InstSvg from './Pages/assets/media/instagram.png'
import TwitSvg from './Pages/assets/media/twitter.png'
import EventSvg from './Pages/assets/event_svg'
import { NavLink, Outlet } from 'react-router-dom'

export default function App() {

 
  
  return (
    <div className='App'>
        <section className='App-nav'>
         <img height='80px' src={logo} alt="" />
         <ul>
          <li><NavLink className='nav-link' to=''><span><HomeSvg/></span> <span> Home</span></NavLink></li>
          <li><NavLink className='nav-link' to='menu'><span><MenuSvg/></span> <span> Menu</span></NavLink></li>
          <li><NavLink className='nav-link mobile' to='contact'><span><MsgSvg/></span> <span> Contact</span></NavLink></li>
         </ul>
        </section>
        <section className='App-content'>
          <div className="loading">
            <div className="spinner">
            <Spinner animation="border" variant="warning" />
            </div>
          </div>
          <Outlet/>
        </section>
        <section className='App-footer'>
          <div className="socials">
            <a id='face' href="https://www.facebook.com/people/BeeHive-Cafe/100043368771388/" target="_blank" rel="noopener noreferrer"><img height={'36px'} src={FaceSvg} alt="" /></a>
            <a id='insta' href="https://www.instagram.com/bee_hive_cafe/?hl=en" target="_blank" rel="noopener noreferrer"><img height={'36px'} src={InstSvg} alt="" /></a>
            <a id='twit' href="https://twitter.com/cafe_beehive?lang=en" target="_blank" rel="noopener noreferrer"><img height={'36px'} src={TwitSvg} alt="" /></a>
          </div>
          <div className="copy">
            © 2022 @ BeeHive Cafe by Mothule
          </div>
        </section>
    </div>
  )
}
